// Decorator
export function ssr_wait(target, name, descriptor) {
  const original = descriptor.value;
  /* istanbul ignore else */
  if (typeof original === 'function') {
    descriptor.value = function (...args) {
      const result = original.apply(this, args);
      /* istanbul ignore else */
      if (
        this.props.ssr !== false &&
        this.context &&
        this.context.queue &&
        typeof this.context.queue.addToQueue === 'function'
      ) {
        this.context.queue.addToQueue(result);
      }

      return result;
    };
  }

  return descriptor;
}
